'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import Link from 'components/consumer/Link';
import classNames from 'classnames';
import avo from 'analytics/avo';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from 'components/consumer/consumer-search/commons/helpers';
const getLabel = (indexName, query) => {
  const capitalized = query.charAt(0).toUpperCase() + query.slice(1);
  switch (indexName) {
    case ALGOLIA_INDEX_NAME.PRODUCTS:
      return 'Products';
    case ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS:
      return `${capitalized} in Customer Photos`;
    case ALGOLIA_INDEX_NAME.REVIEWS:
      return `${capitalized} in Reviews`;
    case ALGOLIA_INDEX_NAME.STATIC_PAGES:
      return `${capitalized} in Pages`;
    default:
      return '';
  }
};
const CATEGORY_LINKS = [{
  indexName: ALGOLIA_INDEX_NAME.PRODUCTS,
  urlIndex: 'products'
}, {
  indexName: ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS,
  urlIndex: ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS
}, {
  indexName: ALGOLIA_INDEX_NAME.REVIEWS,
  urlIndex: ALGOLIA_INDEX_NAME.REVIEWS
}, {
  indexName: ALGOLIA_INDEX_NAME.STATIC_PAGES,
  urlIndex: 'static_pages_new'
}];
const ResultsHeader = t0 => {
  const $ = _c(6);
  const {
    variant: t1,
    children
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const t2 = variant !== "mobile";
  const t3 = variant === "mobile";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = classNames("mx-0 my-2.5 text-base font-bold", {
      "text-gray": t2,
      "text-brand block mt-[15px] mb-[7px]": t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[3] = children;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};

/**
 * ResultsByCategory - Next/v7 mobile variant
 */
const ResultsByCategoryNextMobile = t0 => {
  const $ = _c(29);
  const {
    toggleSearchOpen,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "mobile" : t1;
  const {
    results,
    scopedResults
  } = useInstantSearch();
  const query = results?.query || "";
  const currentPage = useUserCurrentPageType();
  let map;
  if ($[0] !== scopedResults) {
    map = {};
    (scopedResults || []).forEach(t2 => {
      const {
        indexId,
        results: r
      } = t2;
      if (r) {
        map[indexId] = r.nbHits;
      }
    });
    $[0] = scopedResults;
    $[1] = map;
  } else {
    map = $[1];
  }
  const hitsByIndex = map;
  if (!query || !results) {
    return null;
  }
  const t2 = variant === "desktop";
  const t3 = variant === "mobile";
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = classNames("text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8", {
      "block mr-2.5 text-[#585858]": t2,
      "text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block": t3
    });
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const linkClassName = t4;
  let t5;
  let t6;
  let t7;
  if ($[5] !== currentPage || $[6] !== hitsByIndex || $[7] !== linkClassName || $[8] !== query || $[9] !== toggleSearchOpen || $[10] !== variant) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t8;
      if ($[14] !== hitsByIndex) {
        t8 = t9 => {
          const {
            indexName
          } = t9;
          return hitsByIndex[indexName] > 0;
        };
        $[14] = hitsByIndex;
        $[15] = t8;
      } else {
        t8 = $[15];
      }
      const visibleLinks = CATEGORY_LINKS.filter(t8);
      if (!visibleLinks.length) {
        t7 = null;
        break bb0;
      }
      if ($[16] !== variant) {
        t6 = <ResultsHeader variant={variant}>View results by:</ResultsHeader>;
        $[16] = variant;
        $[17] = t6;
      } else {
        t6 = $[17];
      }
      let t9;
      if ($[18] !== currentPage || $[19] !== hitsByIndex || $[20] !== linkClassName || $[21] !== query || $[22] !== toggleSearchOpen) {
        t9 = t10 => {
          const {
            indexName: indexName_0,
            urlIndex
          } = t10;
          return <Link key={indexName_0} to={getAdvancedSearchUrlForQueryAndIndex(query, urlIndex)} onClick={async () => {
            await toggleSearchOpen?.();
            avo.productsSearched({
              query,
              location: currentPage,
              searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
            });
          }} className={linkClassName}>{getLabel(indexName_0, query)} ({hitsByIndex[indexName_0]})</Link>;
        };
        $[18] = currentPage;
        $[19] = hitsByIndex;
        $[20] = linkClassName;
        $[21] = query;
        $[22] = toggleSearchOpen;
        $[23] = t9;
      } else {
        t9 = $[23];
      }
      t5 = visibleLinks.map(t9);
    }
    $[5] = currentPage;
    $[6] = hitsByIndex;
    $[7] = linkClassName;
    $[8] = query;
    $[9] = toggleSearchOpen;
    $[10] = variant;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[24] !== t5) {
    t8 = <div>{t5}</div>;
    $[24] = t5;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t6 || $[27] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[26] = t6;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
export default ResultsByCategoryNextMobile;